import axios from "axios";

const userTagModule = {
  state: {
    allUserTags: [],
  },
  mutations: {
    setAllUserTags(state, tags) {
      state.allUserTags = tags || [];
    },
  },
  actions: {
    async getAllUserTags({ commit }) {
      const res = await axios.get("userTag");
      const tags = res.data.data || res.data;
      commit("setAllUserTags", tags);
      return tags;
    },
  },
  getters: {
    allUserTags: (state) => state.allUserTags || [],
  },
};

export default userTagModule;
